package amazon.lastmile.inject

import com.karawek.core.auth.`internal`.DefaultAuthSessionManager
import com.karawek.core.auth.api.AuthSessionManager
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultAuthSessionManager::class)
public interface ComKarawekCoreAuthInternalDefaultAuthSessionManager {
  @Provides
  public fun provideDefaultAuthSessionManagerAuthSessionManager(defaultAuthSessionManager: DefaultAuthSessionManager): AuthSessionManager = defaultAuthSessionManager
}
